export enum WorkOrderStatus {
  New = 'new',
  Escalated = 'escalated',
  InProgress = 'in-progress',
  Closed = 'closed',
}

export const getWorkOrderStatus = (value: string): WorkOrderStatus => {
  if (!value) return WorkOrderStatus.New

  const matchingStatus = Object.values(WorkOrderStatus).find(
    (enumValue) => enumValue.toLowerCase() === value.toLowerCase()
  )
  if (matchingStatus) {
    return matchingStatus
  }
  return WorkOrderStatus.New
}

export const getWorkOrderStatusLabel = (status: WorkOrderStatus): string => {
  const labels: Record<WorkOrderStatus, string> = {
    [WorkOrderStatus.New]: 'New',
    [WorkOrderStatus.Escalated]: 'Escalated',
    [WorkOrderStatus.InProgress]: 'In Progress',
    [WorkOrderStatus.Closed]: 'Closed',
  }
  return labels[status] ?? status
}

export enum WorkOrderType {
  GreenTagging = 'green_tagging',
  Escalation = 'escalation',
  Update = 'update',
  LocateEquipment = 'locate_equipment',
  Calibration = 'calibration',
}

export const getWorkOrderType = (value: string): WorkOrderType => {
  if (Object.values(WorkOrderType).includes(value as WorkOrderType)) {
    return value as WorkOrderType
  }
  return WorkOrderType.GreenTagging
}

export const getWorkOrderTypeLabel = (type: WorkOrderType): string => {
  const labels: Record<WorkOrderType, string> = {
    [WorkOrderType.GreenTagging]: 'Green Tagging',
    [WorkOrderType.Escalation]: 'Escalation',
    [WorkOrderType.Update]: 'Update',
    [WorkOrderType.LocateEquipment]: 'Locate Equipment',
    [WorkOrderType.Calibration]: 'Calibration',
  }
  return labels[type] ?? type
}

export enum WorkOrderAssignmentType {
  Equipment = 'equipment',
  Assembly = 'assembly',
}
